export default __webpack_public_path__ + "build/83c3cf17c99fd9c204b8e1636b5f0f3e.svg";